import React from 'react';
import { FormattedMessage } from 'react-intl';
import useAuth from 'context/useAuth';

import { AppRoutes } from 'routes';

import { ReactComponent as SessionExpiredIcon } from '../../assets/icons/session-expired.svg';
import { PrimaryButtonSto } from '../../components/sto';

const SessionExpiredPage = () => {
    const { signOut } = useAuth();

    const logOut = () => {
        signOut(AppRoutes.baseRoute);
    };
    return (
        <div className="session-expired grey-banner">
            <div className="session-expired-content box-wrapper">
                <SessionExpiredIcon />
                <p>
                    <FormattedMessage id="session.expired.message" />
                </p>
                <PrimaryButtonSto labelKey="pages.login.connect" onClick={logOut} type="submit" />
            </div>
        </div>
    );
};

export default SessionExpiredPage;
